/**
 * In-app webview detection (KakaoTalk / Instagram / Facebook / Line / Naver).
 * These embedded WKWebViews/Custom Tabs have known getUserMedia/WebRTC
 * quirks (this game's entire premise is camera + optionally WebRTC video) —
 * we never block the app, main.ts just shows a dismissible banner steering
 * the user to a real browser.
 */

const IN_APP_PATTERNS: readonly RegExp[] = [
  /KAKAOTALK/i,
  /Instagram/i,
  /FBAN|FBAV/i, // Facebook app's in-app browser
  /Line\//i,
  /NAVER/i,
];

export function isInAppBrowser(ua: string = navigator.userAgent): boolean {
  return IN_APP_PATTERNS.some((p) => p.test(ua));
}

export function isAndroidUA(ua: string = navigator.userAgent): boolean {
  return /Android/i.test(ua);
}

/**
 * Best-effort Android "open in Chrome" intent URL for the current page. Only
 * ever rendered as a plain `<a href>` (item 2's "best-effort <a>") — if
 * Chrome isn't installed or the in-app browser blocks intent navigation, the
 * tap silently does nothing further; there is no JS fallback to chase here.
 */
export function androidChromeIntentUrl(url: string): string {
  const u = new URL(url);
  const scheme = u.protocol.replace(":", "");
  return `intent://${u.host}${u.pathname}${u.search}${u.hash}#Intent;scheme=${scheme};package=com.android.chrome;end`;
}
